module.exports = __webpack_public_path__ + "static/img/02.55dd9a2e.png";